import { useMemo } from "react";
import { UsersRound, TrendingUp, TrendingDown, Wallet, Landmark } from "lucide-react";
import { teamSummaries, formatTRY, formatInt } from "../data/mock";

export default function SahaEkipleri() {
  const teams = useMemo(() => teamSummaries({}), []);

  return (
    <div className="space-y-5" data-testid="page-saha-ekipleri">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <UsersRound className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Saha Ekipleri</h1>
          <p className="text-xs text-slate-500">{teams.length} bayi · minimum yatırım seviyeleri</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {teams.map((t) => (
          <div key={t.id} className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden" data-testid={`team-card-${t.id}`}>
            <div className="h-1.5" style={{ background: t.color }} />
            <div className="p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <span className="w-11 h-11 rounded-xl flex items-center justify-center text-white font-extrabold text-sm" style={{ background: t.color }}>
                    {t.name}
                  </span>
                  <div>
                    <h3 className="font-extrabold text-lg">{t.name}</h3>
                    <span className="text-xs text-slate-500 flex items-center gap-1"><Landmark size={12} /> {t.hesapSayisi} hesap</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[11px] text-slate-400 font-semibold">MİN. YATIRIM</div>
                  <div className="text-lg font-extrabold" style={{ color: t.color }}>{t.minLabel}</div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-5">
                <div className="rounded-xl bg-slate-50 dark:bg-slate-800/50 p-3">
                  <div className="text-xs text-slate-500 flex items-center gap-1"><TrendingUp size={13} className="text-green-500" /> Yatırım</div>
                  <div className="font-bold text-green-600 mt-0.5">{formatTRY(t.yatirim)}</div>
                </div>
                <div className="rounded-xl bg-slate-50 dark:bg-slate-800/50 p-3">
                  <div className="text-xs text-slate-500 flex items-center gap-1"><TrendingDown size={13} className="text-red-500" /> Çekim</div>
                  <div className="font-bold text-red-500 mt-0.5">{formatTRY(t.cekim)}</div>
                </div>
                <div className="rounded-xl bg-slate-50 dark:bg-slate-800/50 p-3">
                  <div className="text-xs text-slate-500 flex items-center gap-1"><Wallet size={13} className="text-orange-500" /> Bakiye</div>
                  <div className="font-bold text-orange-500 mt-0.5">{formatTRY(t.bakiye)}</div>
                </div>
                <div className="rounded-xl bg-slate-50 dark:bg-slate-800/50 p-3">
                  <div className="text-xs text-slate-500">İşlem Adedi</div>
                  <div className="font-bold mt-0.5">{formatInt(t.adet)}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
